/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportAnamnesisDtoPreviousTherapyStatus =
  (typeof ClinicalReportAnamnesisDtoPreviousTherapyStatus)[keyof typeof ClinicalReportAnamnesisDtoPreviousTherapyStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportAnamnesisDtoPreviousTherapyStatus = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
